// Lib
// NOTE: This will add the custom long-press event to the DOM
import 'long-press-event';

// Utils
import { getPagePositionFromClientPosition } from '../domUtil';
import { createGetRelativePositionFromEventFn } from './domEventUtil';

export const getClientPositionFromLongPress = (event) => ({
    x: event?.detail?.clientX || 0,
    y: event?.detail?.clientY || 0,
});

export const getPagePositionFromLongPress = (event) => {
    const clientOffset = getClientPositionFromLongPress(event);
    return getPagePositionFromClientPosition(clientOffset);
};

export const getRelativePositionFromLongPressEvent = createGetRelativePositionFromEventFn(getPagePositionFromLongPress);
